import { useState, useEffect, useCallback } from "react";
import "./styles/EmailTemplates.css";

import instance from "../../axios";
import { getUserToken } from "../../utils/userAuthenticate";

import { useTranslation } from "react-i18next";
import "../../localisation/index";

import Spinner from "../../components/Loaders/Spinner";
import { createPortal } from "react-dom";

import CustomiseEmailTemplate from "@/components/EmailTemplates/CustomiseEmailTemplate";
import ViewTemplate from "@/components/EmailTemplates/ViewTemplate";
import CustomiseSelfBuyTemplate from "@/components/EmailTemplates/CustomerSelfBuyTemplate";

export default function ManageTemplates() {
    const { t } = useTranslation();
    const templatesTabs=[{id:'buy-for-self', title: t("emailTemplates.buyForSelf")},{id:'send-as-gift', title: t("emailTemplates.sendAsGift") }]
    const [errorMsg, setErrorMsg] = useState("")
    const [viewType, setViewType] = useState("LOADING")
    const [selectedTabItem, setSelectedTabItem] = useState(templatesTabs[0].id)
    const [selectedTemplate, setSelectedTemplate] = useState({})
    const [emailTemplates, setEmailTemplates] = useState([]);

    const fetchTemplates = useCallback(async (isListView = false) => {
        try {
            setViewType("LOADING")
            setErrorMsg("")

            const url = `/mail-template/get-all?page=1&limit=10&type=${selectedTabItem}`;
            const headers = { Authorization: getUserToken() };
            const res = await instance.post(url, {}, { headers });
            const {success, message, data} = res.data
            if(success){    
                const {templates} = data
                setEmailTemplates(templates);
                setViewType("TEMPLATE_LIST")
            } else {
                setErrorMsg(message)
                setViewType("ERROR")
            }
        } catch (error) {
            setErrorMsg(error.message)
            setViewType("ERROR")
        }
    }, [selectedTabItem]);

    useEffect(() => {
        fetchTemplates();
    }, [selectedTabItem, fetchTemplates]);

    const renderErrorView = () => (
        <div className="error-container">
            <p>{errorMsg}</p>
            <button onClick={fetchTemplates}>{t("emailTemplates.tryAgain")}</button>
        </div>
    );

    const renderViewTemplate=async(template, isDetailView)=>{
        try {
            setViewType("LOADING")
            setErrorMsg("")

            const url = `/mail-template/get-by-id?id=${template._id}`;
            const headers = { Authorization: getUserToken() };
            const res = await instance.post(url, {}, { headers });
            const {success, message, data} = res.data
            if(success){    
                const { translatedTemplate, updatedValues, defaultValues, emailConfig, categoryTemplates } = data
                setSelectedTemplate({html_content: translatedTemplate, id: template._id, defaultValues, updatedValues, emailConfig, categoryTemplates});
                if(selectedTabItem === 'buy-for-self'){
                    isDetailView ? setViewType("SELFBUY_TEMPALTE_DETAIL") : setViewType("VIEW_TEMPLATE")
                }else if(selectedTabItem === 'send-as-gift'){
                    isDetailView ? setViewType("TEMPLATE_DETAIL") : setViewType("VIEW_TEMPLATE")   
                }
                // if(selectedTabItem==='buy-for-self'){
                //     setViewType("SELFBUY_TEMPALTE_DETAIL")
                // }
            }else{
                setErrorMsg(message)
                setViewType("ERROR")
            }
        } catch (error) {
            setErrorMsg(error.message)
            setViewType("ERROR")
        }
    }

    const renderListView=()=>{
        return (
            <div className="email-templates-container">
                <div className="templates-switching-tabs">
                    <ul className="templates-tabs-list">
                        {templatesTabs.length > 0 &&
                            templatesTabs.map((tab, index) => (
                                <li
                                    key={index}
                                    onClick={() => setSelectedTabItem(tab.id)}
                                    className={`templates-tab__item ${selectedTabItem === tab.id ? 'active' : ''}`}
                                >
                                {tab.title}
                                </li>
                            ))
                        }
                        <span className={`moving-bg ${selectedTabItem === 'buy-for-self' ? 'tab-left' : 'tab-right'}`}> </span>
                    </ul>
                </div>
                <div>
                {emailTemplates.length===0 ? (
                    <div className="error-container">{t("emailTemplates.noTemplates")}</div>
                ) : (
                    <ul className="template-container">
                        {emailTemplates.map((template, index) => (
                            <li className="template-card">
                                <div>
                                    <div className="template-card__header">
                                        {
                                            !template.isSelected ? (
                                                <span className="template-card__selected">{t("emailTemplates.selected")}</span>
                                            ) : (
                                                <button className="template-card__select">{t("emailTemplates.select")}</button>
                                            )
                                        }
                                        <div>
                                            <button className="template-card__view" onClick={()=>{renderViewTemplate(template, false)}}>{t("emailTemplates.view")}</button>
                                            <button className="template-card__customise" onClick={()=>{renderViewTemplate(template, true)}}>{t("emailTemplates.customise")}</button>
                                        </div>
                                    </div>
                                    <div className="template-card__content">
                                        <img src={template.preview_url} alt="" />
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                )}
                </div>
            </div>
        )
    }
    
    const renderViewType=()=>{
        switch (viewType) {
            case 'LOADING':
                return createPortal(<Spinner />, document.getElementById("portal"));
            case 'ERROR':
                return renderErrorView()
            case 'TEMPLATE_LIST':
                return renderListView()
            case 'VIEW_TEMPLATE':
                return <ViewTemplate setViewType={setViewType} template={selectedTemplate} />
            case 'TEMPLATE_DETAIL':
                return <CustomiseEmailTemplate setViewType={setViewType} template={selectedTemplate}  />
            case 'SELFBUY_TEMPALTE_DETAIL':
                return <CustomiseSelfBuyTemplate setViewType={setViewType} template={selectedTemplate} />
            default:
                break;
        }
    }

    return renderViewType()
}
